import messages from 'containers/SignupPages/AuthByContract/messages';
import { translate } from 'helpers/intl';
import { find } from 'lodash';
import { isDrpp, isNumAdhesion } from 'utils/amcUtils';
import { PRIVILEGES } from 'utils/globalConst';
import * as Yup from 'yup';

export default (props: any) =>
  Yup.object().shape({
    typeAssurance: Yup.string().required('Required'),
    numPolice: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return (
            typeAssurance === PRIVILEGES.AUTO ||
            typeAssurance === PRIVILEGES.MRH ||
            typeAssurance === PRIVILEGES.EPARGN
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    product: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return typeAssurance === PRIVILEGES.EPARGN;
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    dateEffet: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return typeAssurance === PRIVILEGES.EPARGN;
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    matricule: Yup.string()
      .notRequired()
      .when('product', {
        is: (product) => {
          return (
            find(props.productEpargn, { value: product })?.matricule ===
            'INPUT OBLIGATOIR'
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    numAdhesion: Yup.string()
      .notRequired()
      .when('product', {
        is: (product) => {
          return (
            find(props.productEpargn, { value: product })?.numAdhesion ===
            'INPUT OBLIGATOIR'
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    ppr: Yup.string()
      .notRequired()
      .when('product', {
        is: (product) => {
          return (
            find(props.productEpargn, { value: product })?.ppr ===
            'INPUT OBLIGATOIR'
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    organization: Yup.object()
      .nullable()
      .when('typeAssurance', {
        is: (typeAssurance) => typeAssurance === PRIVILEGES.AMC,
        then: Yup.object().required(translate(messages.requiredField, props)),
        otherwise: Yup.object().nullable(),
      }),
    drpp: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) => organization && isDrpp(organization?.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
    membershipNumber: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) =>
          organization &&
          isNumAdhesion(organization?.numAdhesion, organization?.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
  });
